import { NAVIGATION_LINKS } from "src/routes";

export const adminLayoutNavigationLinks: NAVIGATION_LINKS = [];
